var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import * as ServiceAffaire from '../../services/affaire';
import * as ServiceClient from '../../services/client';
import { FormikGenerator, TYPES, } from '../../utils/FormikGenerator';
import { Modal } from '../../utils/Modal';
import { CollaborateurIcon } from '../../utils/Icons';
import * as ServiceUtils from '../../services/utils';
import { EquipeSchema } from '../../utils/ValidationSchema';
export var TYPES_EQUIPE = {
    AFFAIRE: 'Affaire',
    CLIENT: 'Client',
};
export var EditionEquipe = function (props) {
    var ObjetId = props.ObjetId, ObjetType = props.ObjetType, handleClose = props.handleClose;
    var _a = useState([]), collaborateurs = _a[0], setCollaborateurs = _a[1];
    useEffect(function () {
        var getData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ServiceUtils.getSelectOptions('collaborateurs', {
                            ClientOfAffaireId: ObjetType === TYPES_EQUIPE.AFFAIRE ? ObjetId : null,
                        })];
                    case 1:
                        data = _a.sent();
                        setCollaborateurs(data);
                        return [2 /*return*/];
                }
            });
        }); };
        getData();
    }, []);
    var onSubmit = function (_a) {
        var CollaborateurId = _a.CollaborateurId;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(ObjetType === TYPES_EQUIPE.CLIENT)) return [3 /*break*/, 2];
                        return [4 /*yield*/, ServiceClient.postClientEquipe(ObjetId, CollaborateurId)];
                    case 1:
                        _b.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        if (!(ObjetType === TYPES_EQUIPE.AFFAIRE)) return [3 /*break*/, 4];
                        return [4 /*yield*/, ServiceAffaire.postAffaireEquipe(ObjetId, CollaborateurId)];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4:
                        handleClose();
                        return [2 /*return*/];
                }
            });
        });
    };
    return (_jsx(_Fragment, { children: _jsx(Modal, __assign({ handleCloseModal: handleClose, forceOpen: true, title: "Ajout d'un membre", iconTitle: _jsx(CollaborateurIcon, {}) }, { children: _jsx(FormikGenerator, { validationSchema: EquipeSchema, fields: [
                    [
                        {
                            label: 'Collaborateur',
                            name: 'CollaborateurId',
                            type: TYPES.SELECT,
                            options: collaborateurs,
                        },
                    ],
                ], onSubmit: onSubmit, submitLabel: "Ajouter" }) })) }));
};
//# sourceMappingURL=EditionEquipe.js.map